import React from 'react';

const OriginalSizeIcon = props => (
  <svg viewBox="0 0 20 18" {...props}>
    <path d="M0,0V18H20V0ZM7.42,12.5H6V8H4.24V6.89A2.84,2.84,0,0,0,5,6.83a1.85,1.85,0,0,0,.62-.23A1.26,1.26,0,0,0,6,6.17a1.49,1.49,0,0,0,.25-.67H7.42Zm3.82,0H9.67V11h1.57Zm0-3.54H9.67V7.42h1.57Zm4.52,3.54H14.34V8H12.58V6.89a2.73,2.73,0,0,0,.71-.06,1.9,1.9,0,0,0,.63-.23,1.26,1.26,0,0,0,.46-.43,1.49,1.49,0,0,0,.25-.67h1.13Z"/>
  </svg>
);

export default OriginalSizeIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/original-size-icon.js